// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const aiModelInAuthMax = 40;

export const aiModelInCapabilityDefault = `chat`;
export const aiModelInConfigDefault = {};
export const aiModelInDisplayNameMax = 200;

export const aiModelInEnabledDefault = true;
export const aiModelInHostingMax = 40;

export const aiModelInMaxOutputTokensMin = 256;
export const aiModelInMaxOutputTokensMax = 200000;

export const aiModelInModelIdMax = 300;

export const aiModelInPriceCacheReadOneMin = 0;
export const aiModelInPriceCacheReadOneMax = 99999999.9999;

export const aiModelInPriceCacheWriteOneMin = 0;
export const aiModelInPriceCacheWriteOneMax = 99999999.9999;

export const aiModelInPriceInputOneMin = 0;
export const aiModelInPriceInputOneMax = 99999999.9999;

export const aiModelInPriceOutputOneMin = 0;
export const aiModelInPriceOutputOneMax = 99999999.9999;

export const aiModelInSortOrderDefault = 0;

export const AiModelIn = zod.object({
  "auth": zod.string().max(aiModelInAuthMax),
  "capability": zod.enum(['chat', 'embedding']).default(aiModelInCapabilityDefault),
  "config": zod.record(zod.string(), zod.unknown()).default(aiModelInConfigDefault),
  "display_name": zod.string().min(1).max(aiModelInDisplayNameMax),
  "enabled": zod.boolean().default(aiModelInEnabledDefault),
  "hosting": zod.string().max(aiModelInHostingMax),
  "max_output_tokens": zod.int().min(aiModelInMaxOutputTokensMin).max(aiModelInMaxOutputTokensMax),
  "model_id": zod.string().min(1).max(aiModelInModelIdMax),
  "price_cache_read": zod.union([zod.number().min(aiModelInPriceCacheReadOneMin).max(aiModelInPriceCacheReadOneMax),zod.string()]),
  "price_cache_write": zod.union([zod.number().min(aiModelInPriceCacheWriteOneMin).max(aiModelInPriceCacheWriteOneMax),zod.string()]),
  "price_input": zod.union([zod.number().min(aiModelInPriceInputOneMin).max(aiModelInPriceInputOneMax),zod.string()]),
  "price_output": zod.union([zod.number().min(aiModelInPriceOutputOneMin).max(aiModelInPriceOutputOneMax),zod.string()]),
  "sort_order": zod.int().default(aiModelInSortOrderDefault)
});

export type AiModelIn = zod.input<typeof AiModelIn>;
export type AiModelInOutput = zod.output<typeof AiModelIn>;
